var m = require('mithril');
var prop = require('mithril/stream');
var searchEquipmentOverall = require('../../locations/components/searchEquipmentOverall');
var reportsMenu = require('../../equipment/components/reportsMenu');
var preferredNumberOfRowsEditor = require('../../equipment/components/preferredNumberOfRowsEditor');
var choices = require('../../libs/choices');
var equipmentOverviewTable = require('../../equipment/components/equipmentOverviewTable');


var searchEquipmentComponent = {};
searchEquipmentComponent.oninit = function(vnode) {
  var ctrl = this;
  var initial = typeof vnode.attrs.searchEquipmentActive === 'function'
    ? !!vnode.attrs.searchEquipmentActive()
    : false;
  ctrl.searchEquipmentActive = prop(initial);
  ctrl.focusToken = initial ? 1 : 0;
  if (initial) {
    ensureSearchInputGetter(vnode.attrs);
    focusSearchInput(vnode.attrs);
  }
}

var ensureSearchInputGetter = function (attrs) {
  if (!attrs) { return; }
  if (typeof attrs.getSearchInput !== 'function') {
    attrs.getSearchInput = function () {
      return document.getElementById('equipment-paginated-table-search-input');
    };
  }
};
var focusSearchInput = function (attrs) {
  if (!attrs) { return; }
  var getter = typeof attrs.getSearchInput === 'function' ? attrs.getSearchInput : function () {
    return document.getElementById('equipment-paginated-table-search-input');
  };
  var attempts = 0;
  var maxAttempts = 8;
  var attemptFocus = function () {
    var input = getter();
    if (input && typeof input.focus === 'function') {
      input.focus();
      if (typeof input.select === 'function') {
        input.select();
      }
      return true;
    }
    if (attempts++ < maxAttempts) {
      setTimeout(attemptFocus, 25);
    }
    return false;
  };
  requestAnimationFrame(attemptFocus);
};

searchEquipmentComponent.view = function(vnode) {
  ensureSearchInputGetter(vnode.attrs);
  var ctrl = this;
  var isActive = !!ctrl.searchEquipmentActive();
  var containerClass = `div.cf.mh3.bw1.mv2.b--grey${isActive ? '.pv3.bt.pl2.bl' : '.pa3.ba'}`;
  var equipmentRids = vnode.attrs.searchedEquipmentRids();

  return m(containerClass, {
    style: {
      'border-left-style': isActive ? 'dotted' : 'solid'
    }
  }, [
    m('div.v-btm.flex.justify-between.items-center.flex-wrap.pointer', {
      onclick: function () {
        var nextActive = !isActive;
        ctrl.searchEquipmentActive(nextActive);
        if (typeof vnode.attrs.searchEquipmentActive === 'function') {
          vnode.attrs.searchEquipmentActive(nextActive);
        }
        if (nextActive) {
          ctrl.focusToken = (ctrl.focusToken || 0) + 1;
          focusSearchInput(vnode.attrs);
        }
      }
    }, [
      m('div.flex.items-center.overflow-hidden', [
        m(`div.f2`, 'Search')
      ]),
      m('div.flex.items-center', [
        m(`i.icon.fr.blue${isActive ? '.ion-close.f3.mr3' : '.ion-chevron-down.f3'}`)
      ])
    ]),
    m(`div.justify-between.moon-gray.flex-wrap${isActive ? '.flex' : '.dn'}`, [
      m('div.flex.pt2', [          
        m(searchEquipmentOverall, {
          searchEquipmentActive: vnode.attrs.searchEquipmentActive,
          searchEquipmentValue: vnode.attrs.searchEquipmentValue,
          searchedEquipmentRids: vnode.attrs.searchedEquipmentRids,
          location: vnode.attrs.location,
          preferredNumberOfRowsValue: vnode.attrs.preferredNumberOfRowsValue,
          equipmentToShow: vnode.attrs.equipment,
          equipmentClassesSelected: vnode.attrs.equipmentClassesSelected,
          equipmentTableLoading: vnode.attrs.equipmentTableLoading,
          getSearchInput: vnode.attrs.getSearchInput,
          focusToken: ctrl.focusToken
        }),
        m(reportsMenu, {            
          equipmentAllRids: function () { return equipmentRids; },
          location: vnode.attrs.location,
        }),
      ]),
      m('div.flex.flex-wrap.pt2', [
        m('span.ba.b--blue.br2.ph1.flex.items-center.h2', [
          m('label.mr2.f5.blue.nowrap', 'Row limit:'),
          m(preferredNumberOfRowsEditor, {
            location: vnode.attrs.location,
            preferredNumberOfRows: vnode.attrs.preferredNumberOfRows,
            preferredNumberOfRowsValue: vnode.attrs.preferredNumberOfRowsValue
          })
        ])
      ])
    ]),
    m(`div.pt2${isActive ? '' : '.dn'}`, [
      m(choices, {
        data: vnode.attrs.equipmentClassesArray, 
        value: vnode.attrs.equipmentClassesSelected,
        onchange: function () {
          m.redraw();
          if (typeof vnode.attrs.searchEquipmentActive === 'function' && !vnode.attrs.searchEquipmentActive()) {
            vnode.attrs.searchEquipmentActive(true);
          }
        },
        containerInnerClass: 'choices__inner_transparent',
        placeholderValue: 'Select Classes',
      })
    ]),
    m(equipmentOverviewTable, {
      searchEquipmentValue: vnode.attrs.searchEquipmentValue,
      location: vnode.attrs.location,
      equipment: vnode.attrs.equipment,
      preferredNumberOfRowsValue: vnode.attrs.preferredNumberOfRowsValue, 
      searchEquipmentValue: vnode.attrs.searchEquipmentValue,
      searchedEquipmentRids: vnode.attrs.searchedEquipmentRids,
      equipmentClassesSelected: vnode.attrs.equipmentClassesSelected,
      equipmentTableLoading: vnode.attrs.equipmentTableLoading,
      searchEquipmentActive: ctrl.searchEquipmentActive,
    })
  ])
  
}

module.exports = searchEquipmentComponent;
